/**
 * @generated SignedSource<<f81b071e08cedc4831d8ba77ffcfa374>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateVSTSVerificationKeyInput = {
  currentUrl?: string | null;
  vstsAccount?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createVstsVerificationKeyMutation$variables = {
  input: CreateVSTSVerificationKeyInput;
};
export type createVstsVerificationKeyMutation$data = {
  readonly createVSTSVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createVstsVerificationKeyMutation = {
  variables: createVstsVerificationKeyMutation$variables;
  response: createVstsVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateVSTSVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createVSTSVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createVstsVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createVstsVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f29348922cd6f2942cd1c2a67b72b1e2",
    "id": null,
    "metadata": {},
    "name": "createVstsVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createVstsVerificationKeyMutation(\n  $input: CreateVSTSVerificationKeyInput!\n) {\n  createVSTSVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ebd0b288edc07bb2198edb57a51707b";

export default node;
